module.exports = __webpack_public_path__ + "img/media-icon.7fcf62b9.svg";